module.exports = __webpack_public_path__ + "static/media/01_Citation_Set.c9d39cc8.png";